/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useRef } from 'react';
import { filter } from 'lodash';
import axios from 'axios';
import { Button, Backdrop, CircularProgress } from '@mui/material';
import Notification from '../../shared/notification-modal';
// shared
import { getCalculatedRows, decimalFormatter } from '../../shared/helper';
import { defaultModalOptions, waterCompositionsData, cationsProp, anionsProp } from '../../shared/constantVariable';

/* eslint-disable */
let populateDataintoTable;
/* eslint-enable */

const FeedUploadFile = (props) => {
  const { setRowData, setDisableBalance, params, setParams, setCations, setAnions, setpdfdropdown,
    setpdfDdMenuItem, setFileUploadStatus, translateObject, units } = props;

  let localParams = params;

  const [, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [pdfResult, setPdfResult] = useState({});
  const fileInputRef = useRef(null);
  const localwaterCompositionsData = {
    1: {
      cations: [
        { Ion: 'Ca++', IonCode: 'Ca++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'Mg++', IonCode: 'Mg++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'Na+', IonCode: 'Na+', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'K+', IonCode: 'K+', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'NH4+', IonCode: 'NH4+', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'Ba++', IonCode: 'Ba++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'Sr++', IonCode: 'Sr++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'Fe++', IonCode: 'Fe++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      ],
      anions: [
        { Ion: 'SO4--', IonCode: 'SO4--', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'Cl-', IonCode: 'Cl-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'F-', IonCode: 'F-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'NO3-', IonCode: 'NO3-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'PO4---', IonCode: 'PO4---', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'SiO2', IonCode: 'SiO2', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'H2S', IonCode: 'H2S', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'HCO3-', IonCode: 'HCO3-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'CO2', IonCode: 'CO2', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
        { Ion: 'CO3--', IonCode: 'CO3--', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      ]
    }
  };

  // Calculate the entire row based on an unit type value
  const getIonscalculatedRows = (ion, value, unit) => {

    const dummyObj = { Ion: '', IonCode: '', ionType: '', MgL: 0, Meq: 0, ppmAsCaCO3: 0 };
    let filteredData;

    if (ion.includes('+')) {    // cation
      dummyObj.ionType = 'cations';
      filteredData = filter(cationsProp, { Ion: ion });
    } else if (ion.includes('-')) { // anion  leaving some non charge ion
      dummyObj.ionType = 'anions';
      filteredData = filter(anionsProp, { Ion: ion });
    } else if (ion === 'malk') {
      localParams = { ...localParams, malk: value };
      return false;
    } else if (ion === 'ph') {
      localParams = { ...localParams, ph: value };
      return false;
    } else if (ion === 'toc') {
      localParams = { ...localParams, toc: value };
      return false;
    } else if (ion === 'temp') {
      if (unit === '°C')
        localParams = { ...localParams, temperatureDc: Number(value) };
      else if (unit === '°F')
        localParams = { ...localParams, temperatureFh: Number(value) };
      else
        localParams = { ...localParams, temperatureDc: 25 };
      return false;
    } else {  // catching remaining anion without (-)charge wala
      dummyObj.ionType = 'anions';
      filteredData = filter(anionsProp, { Ion: ion });
    }
    const { mass, charge } = filteredData[0];
    const abs = Math.abs(charge);
    dummyObj.Ion = ion;
    dummyObj.IonCode = ion;
    if (unit === 'MgL') {
      const fixed = Number(Number(value).toFixed(2));
      dummyObj.MgL = fixed;
      dummyObj.Meq = abs > 0 ? fixed / (mass / abs) : fixed / mass;
      dummyObj.ppmAsCaCO3 =
        abs > 0 ? (fixed * 50.0435) / (mass / abs) : (fixed * 50.0435) / mass;
    }
    if (unit === 'Meq') {
      const fixed = Number(Number(value).toFixed(4));
      dummyObj.Meq = fixed;
      dummyObj.MgL = abs > 0 ? fixed * (mass / abs) : fixed * mass;
      dummyObj.ppmAsCaCO3 = fixed * 50.0435;
    }
    if (unit === 'ppmAsCaCO3') {
      const fixed = Number(Number(value).toFixed(2));
      dummyObj.ppmAsCaCO3 = fixed;
      dummyObj.MgL =
        abs > 0 ? (fixed * (mass / abs)) / 50.0435 : (fixed * mass) / 50.0435;
      dummyObj.Meq = fixed / 50.0435;
    }
    // Round off ppmAsCaCO3 & Meq
    dummyObj.MgL = parseFloat((dummyObj.MgL).toFixed(2));
    dummyObj.Meq = (dummyObj.Meq).toFixed(4);
    dummyObj.ppmAsCaCO3 = (dummyObj.ppmAsCaCO3).toFixed(2);

    return dummyObj;
  };

  populateDataintoTable = (result) => {
    // reset table value & parameters
    setParams({
      malk: 120.0,
      tds: '',
      ph: 7.0,
      temperatureDc: 25,
      temperatureFh: 77,
      sdi: 4.0,
      toc: 0.0,
      feedFlow: 0.0,
      pressure: 0.0,
    });
    waterCompositionsData[1] = localwaterCompositionsData[1];
    const column = pdfResult[result];
    const cationsData = [];
    const anionsData = [];
    const keys = Object.keys(column);
    for (let i = 0; i < keys.length; i += 1) {
      const currow = getIonscalculatedRows(keys[i], Number(column[keys[i]][0]), column[keys[i]][1]);
      if (!currow) {
        // eslint-disable-next-line
        continue;
      }
      if (keys[i].includes('+'))
        cationsData.push(currow);
      else
        anionsData.push(currow);
    }
    for (let i = 0; i < waterCompositionsData[1].cations.length; i += 1) {
      for (let j = 0; j < cationsData.length; j += 1) {
        if (waterCompositionsData[1].cations[i].Ion === cationsData[j].Ion)
          waterCompositionsData[1].cations[i] = cationsData[j];
      }
    }
    for (let i = 0; i < waterCompositionsData[1].anions.length; i += 1) {
      for (let j = 0; j < anionsData.length; j += 1) {
        if (waterCompositionsData[1].anions[i].Ion === anionsData[j].Ion)
          waterCompositionsData[1].anions[i] = anionsData[j];
      }
    }
    setCations(waterCompositionsData[1].cations);
    setAnions(waterCompositionsData[1].anions);
    setParams({ ...localParams });
    setRowData(getCalculatedRows(waterCompositionsData[1].cations, waterCompositionsData[1].anions));
  };

  const getOutputFilefroms3 = async (fname) => {
    // to get outout file
    try {
      // "proxy": "https://4nl97mvigh.execute-api.us-east-1.amazonaws.com",
      // to get output file from s3 and read the value
      // const outputResponse = await axios({
      //   method: 'post',
      //   // url: 'https://76ryoyiantcdplhoqmzwxpc5va0krrng.lambda-url.us-east-1.on.aws/',
      //   url: 'https://4nf7nlcrysutzjm3hpugldibdy0pdina.lambda-url.us-east-1.on.aws/',
      //   headers: { 'Content-Type': 'text/plain' },
      //   data: {
      //     val: outputFileName
      //   },
      // });
      const URL = process.env.REACT_APP_PDF_TEXTRECT_FILE_OUTPUT;
      // directly getting the response
      const outputResponse = await axios({
        method: 'post',
        // url: 'https://76ryoyiantcdplhoqmzwxpc5va0krrng.lambda-url.us-east-1.on.aws/',
        // lambda function : lmb_pdf_reader_awstextract
        // url: 'https://mtpuhah5okdqek3frkyhyxagcu0kzumk.lambda-url.us-east-1.on.aws/',  // old working

        // url : 'https://2qrwzqx3wk.execute-api.us-east-1.amazonaws.com/dev',
        url: URL,   // new infra
        //    https://mtpuhah5okdqek3frkyhyxagcu0kzumk.lambda-url.us-east-1.on.aws/
        // headers: { 'Content-Type': 'text/plain' },
        headers: { 'Content-Type': 'text/plain' },
        data: fname
      });

      setFileUploadStatus('');
      setLoading(false);
      setFetchLoading(false);
      setDisableBalance(true);
      if (outputResponse.status === 200) {
        const result = outputResponse.data;
        setPdfResult(result);
        setpdfDdMenuItem(Object.keys(result));
        setpdfdropdown(Object.keys(result)[0]);
        populateDataintoTable(Object.keys(result)[0]);
        setFileUploadStatus('');

        // Here we are assuming response temp unit is in 'C'
        // So based on unit selected in UI, we are converting the resvalue to given unit for temp or set to default value
        // by Abhishek on 3-9-25
        const resUnit = result[Object.keys(result)[0]];

        let uploadFileTempinC = resUnit.temp[0];
        let uploadFileTempinF = 77;

        if(units.temp === '°C'){
          uploadFileTempinF =  parseFloat(decimalFormatter(uploadFileTempinC * 1.8 + 32, 2)) || 77 ;
        }else{
          uploadFileTempinC = resUnit.temp[0] || 25 ;
        }

        setParams({
          malk: resUnit.malk[0] || 120.0,
          tds: '',
          ph: resUnit.ph[0] || 7.0,
          temperatureFh: uploadFileTempinF, // resUnit.temp[0] || 77.0,
          temperatureDc: uploadFileTempinC, // resUnit.temp[0] <= 0 ?  25 : resUnit.temp[0] || 25.0,
          sdi: 4.0,
          toc: 0.0,
          feedFlow: 0.0,
          pressure: 1.97
        });
      }

    } catch (err) {
      setpdfDdMenuItem([]);  // remove pdf Dropdown
      setFileUploadStatus('');
      setFetchLoading(false);
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Error',
        message: 'Error while fetching your output response. Please re-try',
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
      setTimeout(() => setFileUploadStatus(''), 1);
      setFileUploadStatus('');
    }
  };

  const handleFileUpload = async (event) => {
    event.preventDefault();
    if (event.target.files.length > 0) {
      setLoading(true);
      setFetchLoading(true);
      setpdfDdMenuItem([]);
      // clear table value & parameter
      setParams({
        malk: 120.0,
        tds: '',
        ph: 7.0,
        temperatureFh: 77.0,
        temperatureDc: 25.0,
        sdi: 4.0,
        toc: 0.0,
        feedFlow: 0.0,
        pressure: 1.97
      });
      waterCompositionsData[1] = localwaterCompositionsData[1];

      const f = event.target.files[0];
      const acceptedFileType = ['text/csv', 'application/vnd.ms-excel',  // by Abhishek on 23-3 : removed pdf type 'application/pdf',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      if (acceptedFileType.includes(f.type)) {
        // Upload any file to S3
        /* We have added "proxy": "https://xx4n0y0ry4.execute-api.us-east-1.amazonaws.com/dev", in package.json
        *  This help us to bypass CROS error (even if we enable it in AWS)
        *  During production, remove it from package.json and add it (only value) before in the url which is used in fetch call
        */
        // URL : https://4nl97mvigh.execute-api.us-east-1.amazonaws.com/uploads3/uploadpdftextract/abhi.pdf  old working one
        //  https://xx4n0y0ry4.execute-api.us-east-1.amazonaws.com/dev/winflows-s3/uploadpdftextract/Testing.txt     winflows infra one

        // const fileUploadRes = await fetch(`/uploads3/uploadpdftextract/${f.name}`, {    // old working
        // "proxy": "https://4nl97mvigh.execute-api.us-east-1.amazonaws.com",

        // new infra
        const URL = process.env.REACT_APP_PDF_TEXTRECT_FILE_UPLOAD;
        const fileUploadRes = await fetch(`${URL}${f.name}`, {
          // "proxy": "https://xx4n0y0ry4.execute-api.us-east-1.amazonaws.com/dev",
          method: 'PUT',
          // use header when you are getting 403 status code error
          headers: {
            'Content-Type': `${f.type}`,  // take type in run-time
          },
          // mode is not supported for PUT method
          // mode: 'no-cors',
          body: f
        }); // eslint-disable-next-line
        if (fileUploadRes.status === 200) {
          setFileUploadStatus('File is Uploaded');
          getOutputFilefroms3(f.name);
        }
        else {
          setFileUploadStatus('Failed to uploaded File');
          setTimeout(() => setFileUploadStatus(''), 1);
          // to get the o/p from lambda
          getOutputFilefroms3(f.name);
        }
      }
      else {  // File format wrong
        setFetchLoading(false);
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Error',
          message: 'Accepted File type: .xlsx/.csv/.xls',   // removed .pdf by Abhishek on 23-3-24
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
      }
    }
    // Reset the file input value to allow re-uploading the same file
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        style={{
          background: '#d9dbde5c',
        }}
        open={fetchLoading}
      >
        <CircularProgress color='inherit' style={{ color: '#4b93f4' }} />
      </Backdrop>
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <div style={{ width: '95%' }}>
        <Button
          variant='contained'
          component='label'
          className=' M_Bold Primary_Default_Button'
          size='small'
          style={{ 'textTransform': 'none', width: '95%', boxShadow: '0px 4px 6px 0px rgba(0, 0, 0, 0.1)', marginTop: '16px' }}
        >
          {translateObject('Upload Water Analysis')}
          <input
            ref={fileInputRef}
            type='file'
            hidden
            id='fileInput'
            onChange={handleFileUpload}
          />
        </Button>
      </div>
    </>
  );
};

export default FeedUploadFile;
export { populateDataintoTable };
